import { EffAiReviewComment } from "../../info-boxes/eff-ai-review-info-box/eff-ai-review.model";
import { EvidenceSampleTestStep } from "../models/evidence-sample-step.model";
import { SampleView } from "../models/sample-view.model";

// The AI text goes in a comment between these lines, so it stays recognizable after saving and a next AI
// proposal replaces it instead of adding a second one. Not translated, so a block is found in every language.
const aiBlockStart = "[AI]";
const aiBlockEnd = "[/AI]";
const aiBlockPattern = /\[AI\]\r?\n[\s\S]*?\r?\n\[\/AI\]/;

export interface AiCommentRow {
    row: EvidenceSampleTestStep;
    comment: string;
}

/**
 * Finds the grid row of each proposed reviewer comment. The comments go in the grid rows, because saving copies the
 * rows to the samples. A comment on a sample that is not on the page is left out.
 */
export function findAiCommentRows(viewSamples: SampleView[], comments: EffAiReviewComment[]): AiCommentRow[] {
    return comments
        .map((aiComment) => ({
            row: viewSamples
                .find((view) => view.sample.guid === aiComment.sampleGuid)
                ?.gridDataSource.data.find((item) =>
                    aiComment.testStepGuid ? !item.isSample && item.guid === aiComment.testStepGuid : item.isSample
                ),
            comment: aiComment.comment,
        }))
        .filter((aiCommentRow) => aiCommentRow.row);
}

export function hasAiBlock(text: string): boolean {
    return !!text && aiBlockPattern.test(text);
}

/**
 * Puts the AI text in its block: it replaces the AI block the text already has, or else goes below the text of
 * the user.
 */
export function setAiBlock(existing: string, comment: string): string {
    const block = `${aiBlockStart}\n${comment}\n${aiBlockEnd}`;
    if (hasAiBlock(existing)) {
        // A function, so a "$" in the comment is not read as a replacement pattern.
        return existing.replace(aiBlockPattern, () => block);
    }

    return existing ? `${existing}\n\n${block}` : block;
}
